var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituation6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3000,
    height: 3000,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    transform: "translate(-1886.56 -721)",
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "none",
    d: "m3767.28223,1355c-1.39,-6.21 -4.06,-11.56 -14,-12c-16,-30.87 -42.16,-54.06 -98,-55l-241,-4l0,-48l3,0l1,-22l-4,0l0,-25l-36,0l0,25l-4,0l1,22l3,0l0,48l-241,4c-55.84,0.94 -82,24.13 -98,55c-9.94,0.44 -12.61,5.79 -14,12l0,1424c-7.92,0.73 -13.7,8.55 -19,18l0,190c4.88,13.58 11,22.1 19,23l0,102c20.64,40.22 46.73,68.87 83,76l0,51l45,12l78,-24l0,-6c47.11,8.45 103.9,10.62 165,10c61.1,0.62 117.89,-1.55 165,-10l0,6l78,24l45,-12l0,-51c36.27,-7.13 62.36,-35.78 83,-76l0,-1757z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0.5,
    x2: 1,
    y1: 0.5,
    x1: 0,
    id: "D\\xE9grad\\xE9_sans_nom_38"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#adadad",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcdcdc",
    offset: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c9c9c9",
    offset: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    offset: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6b6b6",
    offset: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bfbfbf",
    offset: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cfcfcf",
    offset: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcdcdc",
    offset: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dadada",
    offset: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3d3d3",
    offset: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c8c8c8",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7b7b7",
    offset: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#adadad",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 0.49999,
    x2: 1,
    y1: 0.49999,
    x1: 0.00001,
    id: "D\\xE9grad\\xE9_sans_nom_41"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#adadad",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcdcdc",
    offset: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c9c9c9",
    offset: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6b6b6",
    offset: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bfbfbf",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cfcfcf",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcdcdc",
    offset: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dadada",
    offset: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3d3d3",
    offset: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c8c8c8",
    offset: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7b7b7",
    offset: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#adadad",
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chaudi\xE8re seule") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_10",
    fill: "#125377",
    ry: 42.06,
    rx: 54.5,
    cy: 6283.26,
    cx: 370.06999,
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    clipPath: "url(#clip-path)",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "url(#D\\xE9grad\\xE9_sans_nom_38)",
    d: "m1880.72217,634c-1.39,-6.21 -4.06,-11.56 -14,-12c-16,-30.87 -42.16,-54.06 -98,-55l-241,-4l0,-48l3,0l1,-22l-4,0l0,-25l-36,0l0,25l-4,0l1,22l3,0l0,48l-241,4c-55.84,0.94 -82,24.13 -98,55c-9.94,0.44 -12.61,5.79 -14,12l0,1424c-7.92,0.73 -13.7,8.55 -19,18l0,190c4.88,13.58 11,22.1 19,23l0,102c20.64,40.22 46.73,68.87 83,76l0,51l45,12l78,-24l0,-6c47.11,8.45 103.9,10.62 165,10c61.1,0.62 117.89,-1.55 165,-10l0,6l78,24l45,-12l0,-51c36.27,-7.13 62.36,-35.78 83,-76l0,-1757z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_4",
    fill: "#8c2c22",
    height: 8,
    width: 36,
    y: 555,
    x: 1491.72223,
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_5",
    fill: "#3d3333",
    height: 40,
    width: 36,
    y: 515,
    x: 1491.72223,
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 468,
    id: "svg_6",
    fill: "#706852",
    height: 25,
    width: 36,
    x: 1491.72223,
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_7",
    fill: "#666",
    height: 4,
    width: 719,
    y: 618,
    x: 1152.72223,
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_8",
    fill: "#e0e0e0",
    height: 15,
    width: 719,
    y: 603,
    x: 1152.72223,
    className: "cls-8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fill: "url(#D\\xE9grad\\xE9_sans_nom_41)",
    d: "m1186.72217,1996l0,-28l11,-10c65.13,18.85 140.05,25.45 223,22l0,353c-83.08,12.32 -163.07,-7.83 -242,-39l-40,-5c-9.22,-2.1 -15,-10.8 -19,-23c0,0 -1,-173 0,-187.29c4,-9.71 67,-82.71 67,-82.71z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    fill: "#3d3d3d",
    d: "m1344.72217,2506l0,-9c-38.23,0.14 -73.29,-3.48 -78,-43l-46,-12l0,76l46,12l78,-24z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_12",
    fill: "#757575",
    points: "1262.1121826171875,2452.800048828125 1220.72216796875,2442 1220.72216796875,2518 1263.80224609375,2529.239990234375 1262.1121826171875,2452.800048828125 ",
    className: "cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    fill: "#3d3d3d",
    d: "m1670.72217,2508l0,-9c38.23,0.14 73.29,-3.48 78,-43l46,-12l0,76l-46,12l-78,-24z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_14",
    fill: "#757575",
    points: "1794.72216796875,2444 1753.34228515625,2454.800048828125 1751.6522216796875,2531.239990234375 1794.72216796875,2520 1794.72216796875,2444 ",
    className: "cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    fill: "#0b1f40",
    d: "m1711.72217,2120c37.64,-1.81 44,27 43,51c-5.5,27.1 -27.89,32.54 -49,31c0,0 36,3 36,-38s-30,-44 -30,-44z",
    className: "cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    fill: "#b3b3b3",
    d: "m1692.72217,2170l23,8c19.22,0 22.22,-35 3,-35l-15,-5c-13,0 -20,23 -11,32z",
    className: "cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    fill: "#595959",
    d: "m1692.72217,2170l23,8c-20,-3 -10,-35 3,-35l-15,-5c-13,0 -20,23 -11,32z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    fill: "#b3b3b3",
    d: "m1133.55217,2059.58s113.17,22.42 169.17,6.42s113,-54 113,-54s-175,-11 -223,-24c-38,41 -59.17,71.58 -59.17,71.58z",
    className: "cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    fill: "#b3b3b3",
    d: "m1186.72217,1968c68.83,17.69 145.16,24.74 227,24l2,341.7l5,0.3l0,-354c-73.74,5.18 -148,-2 -223,-22l-11,10z",
    className: "cls-14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituation6);
export default __webpack_public_path__ + "static/media/situation_6.e1d0b5146da601b4dab36d6d6a80e53f.svg";
export { ForwardRef as ReactComponent };